<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Search by name"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="[filterEndDate, filterStartDate]"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="account-period-type">Tipo de data</label>
          <select v-model="query.periodType" id="account-period-type" class="form-control">
            <option value="created_at">Criado em</option>
            <option value="updated_at">Atualizado em</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="account-start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="account-start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="account-end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="account-end-date" class="form-control">
        </div>
      </div>
    </template>
    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Status</th>
            <th>Description</th>
            <th>Weight</th>
            <th>Index</th>
            <th>Criado em</th>
            <th>Atualizado em</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.status }}</td>
            <td>{{ item.description }}</td>
            <td>{{ item.weight }}</td>
            <td>{{ item.index }}</td>
            <td>{{ item.createdAt | datetime }}</td>
            <td>{{ item.updatedAt | datetime }}</td>
            <td>
              <button class="btn btn-outline" @click="show(item)">
                Show
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ShowDataModal v-model="showModal" header="Stage" :data="currentStage"/>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import ModelMapper from '@/mixins/ModelMapper'
import GetUser from '@/mixins/GetUser'

import Pagination from '@/components/shares/specialTag/Pagination'
import ShowDataModal from '@/components/admin/ShowDataModal'

import {Filter} from '@/models/filter'
import {ChevronDownIcon, SearchIcon} from 'vue-feather-icons'

export default {
  components: {BadgeFilters, ChevronDownIcon, Pagination, SearchIcon, ShowDataModal},
  computed: {
    items() {
      return this.getModels || []
    }
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.find()
  },
  data: () => ({
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    currentStage: {},
    showModal: false,
    nameModel: 'Stage',
    orderBy: 'created_at',
  }),
  methods: {
    buildPath() {
      return `${this.currentPath}/${this.entityOrder.id}/items`
    },
    find() {
      this.asyncTemplateSelect()
    },
    show(item) {
      this.showModal = true
      this.currentStage = item
    }
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminOrderItems',
  props: {
    entityOrder: {required: true, type: Object},
    currentPath: {required: true, type: String}
  },
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>
